import React from 'react'

type TimerBarProps = {
  windowWidth: number
  timeLimit: number
  minutes: number
  seconds: number
}

const TimerBar: React.FC<TimerBarProps> = ({ timeLimit, minutes, seconds, windowWidth }) => {
  const timerBackgroundBarWidth = windowWidth <= 1300 ? 80 : 86
  const timerRedBarWidth = Math.round(
    ((minutes * 60 + seconds) / (timeLimit * 60)) * timerBackgroundBarWidth
  )
  return (
    <div>
      <div
        className={`absolute bottom-0.5 left-[79px] 1.1xl:left-[76px] z-20 h-6 bg-errorColor rounded`}
        style={{ width: `${timerRedBarWidth}px` }}
      />
      <div
        className={`absolute bottom-0.5 left-[79px] 1.1xl:left-[76px] z-10 h-6 bg-timer_back rounded`}
        style={{ width: `${timerBackgroundBarWidth}px` }}
      />
    </div>
  )
}

export default React.memo(TimerBar)
